<template>
  <v-app>
    <v-content>
      <v-container fluid class="pa-0 ma-0 matchMakingArea" style="height: 100%;background-color: transparent">
        <v-app-bar style="position:relative;z-index: 1;" color="transparent" v-if="$vuetify.breakpoint.mdAndUp"
                   elevation="0">
          <v-row class="text-center">
            <v-col cols="12" lg="12">
              <router-link :to="{name:'dashboard'}">
                <img :src="require('../../assets/simialogopng.png')" style="width: 190px;"
                     v-if="getPlatformInfo('id') == 3">
                <p v-else-if="getPlatformInfo('id')">{{ getPlatformTitle() }}</p>
              </router-link>
            </v-col>
          </v-row>
        </v-app-bar>
        <v-app-bar v-else class="appbarMobile">
          <v-row>
            <v-col cols="4">

            </v-col>
            <v-col cols="4" class="mt-3">
              <router-link :to="{name:'dashboard'}">
                <img :src="require('../../assets/simialogopng.png')" style="width: 100px;"
                     v-if="getPlatformInfo('id') == 3">
                <p v-else-if="getPlatformInfo('id')">{{ getPlatformTitle() }}</p>
              </router-link>
            </v-col>
            <v-col cols="4" class="text-left">
              <router-link :to="{name:'dashboard'}">
                <img src="../../assets/matchMaking/dashboardArrow.svg" alt="">
              </router-link>
            </v-col>
          </v-row>
        </v-app-bar>
        <div class="StepperArea d-flex flex-column  fill-height">
          <div class="circleArea">
            <div class="circleOne">
            </div>
            <div class="circleThree">
            </div>
          </div>
          <div>
            <v-container>
              <div class="StepperContent  d-flex flex-column" style="position: relative">
                <v-fade-transition>
                  <img src="@/assets/matchMaking/register.png"
                       :class="$vuetify.rtl ? 'registerImage' : 'registerImageEn'"
                       alt=""
                       v-if="$vuetify.breakpoint.lg && activeStep == 'register'">
                </v-fade-transition>
                <div class="indicator">
                  <indicator-match-making :steps="steps"/>
                </div>
                <div class="flex-grow-1 d-flex flex-column justify-space-around">
                  <div class="stepArea   text-center">
                    <div class="persinalInfo" v-if="activeStep == 'profile'">
                      <v-fade-transition>
                        <PersonalMatchMaking :next="next" :prev="prev" :step-data="stepsData"/>
                      </v-fade-transition>
                    </div>
                    <div class="matchMakingTest" v-else-if="activeStep == 'selectTherapist'">
                      <v-fade-transition>
                        <MatchMakingTest :language="$vuetify.rtl ? 'fa' : 'en'"
                                         :call-change-in-option="callChangeInOption"
                                         @matchMakingTestEnd="matchMakingTestEnd"
                                         :next="next"
                                         :prev="prev"/>
                      </v-fade-transition>
                    </div>
                    <div class="onBoarding" v-if="activeStep == 'onBoarding'">
                      <v-fade-transition>
                        <OnBoardingMatchMaking class="mt-10" @changeStep="changeStepToRegister($event)"/>
                      </v-fade-transition>
                    </div>
                    <div class="registerMatchMaking" v-else-if="activeStep == 'register'">
                      <v-fade-transition>
                        <RegisterMatchMaking @afterLogin="redirectToPreorder" @sendProfileData="sendProfileData"/>
                      </v-fade-transition>
                    </div>
                  </div>
                </div>
                <div class="arrowArea " v-if="activeStep == 'profile' && $vuetify.breakpoint.lgAndUp">
                  <div class="prevBtn d-flex " @click="activeStepInner != 'category' && prevStepBtn()"
                       :class="activeStepInner == 'category' && 'disableArrow' ">
                    <!--                  <img src="../../assets/matchMaking/Back.svg" :class="activeStepInner == 'category' && 'disableArrow'"-->
                    <!--                       alt="">-->
                    <div class="mx-5 mt-2">
                      {{ $t('onBoarding.prev') }}
                    </div>
                  </div>
                  <div class="nextBtn d-flex" @click="!disableNextBtn && nextStepBtn()"
                       :class="disableNextBtn &&  'disableArrow'">
                    <div class="mx-5 mt-1">
                      {{ $t('onBoarding.next') }}
                    </div>
                    <img src="../../assets/matchMaking/next.svg" :class="disableNextBtn && 'disableArrow'" alt="">
                  </div>
                </div>
              </div>
              <div class="text-center">
                <template v-if="activeStep == 'selectTherapist' ">
                  <v-btn class="confirmBtn" color="#3CBE8B" elevation="0" @click="callOptionChanges"
                         v-if="$vuetify.breakpoint.mdAndDown">
                    {{ $t('matchMaking.buttons.submit') }}
                  </v-btn>
                </template>
              </div>
              <div class="OnboardingBtnArea" style="position: fixed;bottom: 20px;left: 0px;right: 0px;z-index: 30">
                <div class="arrowArea d-flex justify-space-between mt-10 " :class="!$vuetify.rtl && 'flex-row-reverse'"
                     v-if="activeStep == 'profile' && $vuetify.breakpoint.mdAndDown" style="z-index: 999">
                  <div class="prevBtn d-flex "
                       @click="activeStepInner != 'category' && prevStepBtn()"
                       :class="{disableArrow:activeStepInner == 'category','flex-row-reverse':!$vuetify.rtl} ">
                    <img src="../../assets/matchMaking/Back.svg"
                         :class="activeStepInner == 'category' && 'disableArrow'"
                         alt="">
                    <div class="mx-5 mt-2">
                      {{ $t('onBoarding.prev') }}
                    </div>
                  </div>
                  <div class="nextBtn d-flex" @click="!disableNextBtn && nextStepBtn()"
                       :class="{disableArrow:disableNextBtn,'flex-row-reverse':!$vuetify.rtl}">
                    <div class="mx-5 mt-2">
                      {{ $t('onBoarding.next') }}
                    </div>
                    <img src="../../assets/matchMaking/next.svg" :class="disableNextBtn && 'disableArrow'" alt="">
                  </div>
                </div>
              </div>
              <!--            <div class="testimonial mt-10">-->
              <!--              <TestimonialsOnboarding/>-->
              <!--            </div>-->
            </v-container>
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-container class="pa-0">
              <div class="footer">
                <v-row dense>
                  <v-col cols="12" class="pb-0" lg="4" v-if="$vuetify.breakpoint.mdAndUp">
                    made with
                    <v-icon small>mdi-heart-outline</v-icon>
                    at {{ getPlatformInfo('name') }}
                  </v-col>
                  <v-col cols="12" class="pb-0" lg="4" v-if="$vuetify.breakpoint.mdAndUp">
                    copyright 2022 {{ getDomainPlatform() }} All Rights Reserved ©
                  </v-col>
                  <v-col cols="12" class="pb-0" lg="4">
                    <div class="d-flex  text-center"
                         :class="$vuetify.breakpoint.mdAndUp ? 'justify-end' : 'flex-column'">
                      <div style="font-size: 10px" v-if="$vuetify.breakpoint.mdAndDown">
                        2022 {{ getDomainPlatform() }} All Rights Reserved ©
                      </div>
                      <router-link
                          to="https://simiaroom.com/%D8%B4%D8%B1%D8%A7%DB%8C%D8%B7-%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D9%87/">
                        <div class="terms" :class="$vuetify.breakpoint.mdAndDown && 'mt-2'"
                             :style="$vuetify.breakpoint.mdAndDown && 'margin: auto'">
                          {{ $t('signupComponent.terms') }}
                        </div>
                      </router-link>
                    </div>
                  </v-col>
                </v-row>
              </div>

            </v-container>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/*eslint-disable  */
import {EventBus} from "@/event-bus";
import gsap from "gsap";
import TestimonialsOnboarding from "@/components/MatchMaking/TestimonialsOnboarding";
import SelectableWizardMatchMaking from "@/components/MatchMaking/selectableWizardMatchMaking";
import PersonalMatchMaking from "@/components/MatchMaking/PersonalMatchMaking";
import MatchMakingTest from "@/components/MatchMaking/MatchMakingTest";
import RegisterMatchMaking from "@/components/Auth/AuthMatchMaking";
import OnBoardingMatchMaking from "@/components/MatchMaking/OnBoardingMatchMaking";
import IndicatorMatchMaking from "@/components/MatchMaking/IndicatorMatchMaking";

/**
 * <h1>Match making</h1> <p>this is match making test page for onboard user. </p>
 *
 * <p>this page contain 4 step of match making test step :
 *  <br/>
 *  <b>1-PersonalMatchMaking</b><br/>
 *  <b>1-MatchMakingTest</b><br/>
 *  <b>1-OnBoardingMatchMaking</b><br/>
 *  <b>1-RegisterMatchMaking</b><br/>
 * </p>
 * @vue-event Mounted - emit setStepValue on event bus to store current question
 * @vue-event Mounted - emit changeActiveStepInner on event bus to change inner step in active step
 * @vue-data {number} [matchMakingStepper] - match making test window control
 * @vue-data {bool} [showPrivacyPolicySwitch] - show privacy policy modal
 * @vue-data {string|number} [psychologyFieldsSelected] - selected psychology fields Selected
 * @vue-data {number} [currentStep] - hold current step number
 * @vue-data {bool} [loadPsychologyFieldsSelectedForm] - need to get  psychology fields from user
 * @vue-data {object} [steps] - hold test steps order
 * @vue-data {bool} [next] - hold next Status
 * @vue-data {bool} [prev] - hold prev Status
 * @vue-data {string} [activeStep] - hold active step
 * @vue-data {string} [activeStepInner] - hold rendered step in active step
 * @vue-data {string} [activeStepInner] - hold rendered step in active step
 * @vue-data {string} [callChangeInOption] - nested bool for prepare payload when is true
 * @vue-data {object} [stepsData] - hold  what information does each step require?
 * @vue-data {object} [stepsData] - hold  what information does each step require?
 * @vue-computed {boolean} disableNextBtn - Returns a boolean indicating whether or not the "Next" button should be disabled
 * @vue-computed {boolean} largeSize - Returns a boolean indicating whether or not the inner window width is larger than 600 pixels
 * @vue-computed {string} btnLabel - Returns the label to display on the "Next" button, either "بعدی" or "شروع"
 * @vue-computed {string|null} user_token_matchMaking - Gets or sets the user token for the MatchMaking test from localStorage
 * @vue-computed {function} btnMethod - Returns the function to call when the "Next" button is clicked, either checkUserHasPendingTest, getQuestions, or submitAnswer
 * @vue-computed {string} baseUrl - Returns the base URL for the current environment from the VUE_APP_BASE_URL environment variable
 * */

export default {
  components: {
    IndicatorMatchMaking,
    OnBoardingMatchMaking,
    RegisterMatchMaking,
    MatchMakingTest,
    PersonalMatchMaking,
    SelectableWizardMatchMaking,
    TestimonialsOnboarding,
  },
  /**

   */
  data() {
    return {
      matchMakingStepper: 1,
      showPrivacyPolicySwitch: false,
      loading: false,
      targetStep: 3,
      psychologyFields: null,
      psychologyFieldsSelected: null,
      payloadBody: {},
      user_m_test_id: 0,
      currentStep: 1,
      loadPsychologyFieldsSelectedForm: true,
      steps: {
        profile: true,
        selectTherapist: false,
        register: false,
        onBoarding: false,
      },
      next: false,
      prev: false,
      activeStep: 'profile',
      activeStepInner: 'category',
      callChangeInOption: false,
      // activeStepInner: 'temp',
      stepsData: {
        profile: {
          category: null,
          gender: null,
          age: null,
          relationship: null,
        },
        selectTherapist: {
          temp: null,
        },
        register: {}
      },
    }
  },
  methods: {
    /**
     Redirects the user to the preorder page based on the package ID query parameter in the current route, or to a default package ID if not present.
     */
    redirectToPreorder() {
      if (this.$route.query.package_id) {
        this.$router.push({name: "preorder", params: {orderId: this.$route.query.package_id}})
      } else {
        this.$router.push({name: "preorder", params: {orderId: 68}})
      }
    },
    /**

     Changes the active step to the registration step and animates the transition.
     If the user is already logged in, redirects to the preorder page instead.
     */
    changeStepToRegister() {
      if (this.$store.getters.userIsLoggedIn) {
        this.redirectToPreorder()
      }
      gsap.to('.onBoarding', {x: -10, opacity: 0, display: 'none'}).then(() => {
        gsap.fromTo('.registerMatchMaking', {opacity: 0, display: 'none'}, {opacity: 1, display: 'block'})
        setTimeout(() => {
        }, 2000)
      })
      this.activeStep = 'register'
      this.steps.register = true
    },

    /**

     Sends the user's profile data to the server.
     Emits a "setLoading" event before and after sending the request.
     */
    sendProfileData() {
      this.$emitEvent('setLoading', true)
      this.requesting('user', 'SendSurveyAnswer', '', this.stepsData.profile).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },

    /**

     Sets a flag to indicate that an option has been changed.
     Resets the flag in the next tick using a Promise.
     */
    callOptionChanges() {
      this.callChangeInOption = true
      this.$nextTick().then(() => {
        this.callChangeInOption = false
      })
    },

    /**

     Sets a value in the current step's data object and advances to the next step if all required fields in the profile step have been filled.
     @param {string} key - The key to set in the current step's data object.
     @param {*} value - The value to set for the given key.
     @param {boolean} nextStep - Whether to advance to the next step after setting the value.
     */
    setValueStep(key, value, nextStep = false) {
      if (key && value) {
        this.stepsData[this.activeStep][key] = value
      }
      // console.log(this.stepsData.profile)
      switch (this.activeStep) {
        case 'profile':
          if (Object.values(this.stepsData.profile).every(value => value != null)) {
            this.activeStep = 'selectTherapist'
            this.steps.selectTherapist = true
            if (this.$store.getters.userIsLoggedIn) {
              this.sendProfileData()
            }
          }
      }
      if (nextStep) {
        this.nextStepBtn();
      }
      // console.log(this.stepsData)
    },

    /**

     Sets a flag to indicate that the "Next" button has been clicked.
     Resets the flag in the next tick using a Promise.
     */

    nextStepBtn() {
      this.next = true
      this.$nextTick().then(() => {
        this.next = false
      })
    },
    /**

     Sets a flag to indicate that the "Previous" button has been clicked.
     Resets the flag in the next tick using a Promise.
     */
    prevStepBtn() {
      this.prev = true
      this.$nextTick().then(() => {
        this.prev = false
      })
    },
    /**

     Ends the match-making test and sets the active step to the onboarding step.
     Animates the transition using gsap.
     */
    matchMakingTestEnd() {
      this.activeStep = 'onBoarding'
      this.steps.selectTherapist = true
      gsap.fromTo('.onBoarding', {x: 100, opacity: 0, display: 'none'}, {x: 0, opacity: 1, display: 'block'})
    },
  },
  computed: {
    disableNextBtn() {
      if (this.stepsData[this.activeStep][this.activeStepInner]) {
        return false
      }
      return true
    },
    largeSize() {
      return this.innerWidth > 600;
    },
    btnLabel() {
      if (this.currentStep > 1) {
        return "بعدی"
      }
      return "شروع"
    },
    user_token_matchMaking: {
      get() {
        return localStorage.getItem('user_token_matchMaking');
      },
      set(newValue) {
        return localStorage.setItem('user_token_matchMaking', newValue)
      }
    },
    btnMethod() {
      if (this.currentStep == 1) {
        return this.checkUserHasPendingTest
      }
      if (this.currentStep == 2 && this.psychologyFieldsSelected != null) {
        return this.getQuestions
      } else {
        return this.submitAnswer
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    }
  },
  mounted() {
    this.$onEvent('setStepValue', (data) => {
      this.setValueStep(data.key, data.value, data.nextStep)
    })
    this.$onEvent('changeActiveStepInner', (key) => {
      this.activeStepInner = key
    })
  },
  beforeDestroy() {
    EventBus.$off('notify')
  },
  watch: {
    activeStep(newVal) {
      if (newVal === 'selectTherapist') {
        gsap.to('.stepArea', {width: '70%', delay: .3})
        return;
      }
      if (newVal === 'register') {
        gsap.to('.stepArea', {width: '100%', delay: .3})
        return;
      }
    }
  }
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .prevBtn {
    position: relative !important;
  }

  .nextBtn {
    position: relative !important;
  }

  .stepArea {
    width: 90% !important;
  }

  .StepperContent {
    min-height: 500px !important;
  }

  .matchMakingArea {
    overflow: hidden !important;
  }

}

.arrowArea{
  position: relative;
  z-index: 200 !important;
}
.confirmBtn {
  position: fixed;
  bottom: 0px;
  width: 100% !important;
  right: 0px;
  left: 0px;
  border-radius: 0px !important;
}

.registerImage {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 400px;
  height: 100%;
  left: 0px;
}

.registerImageEn {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 400px;
  height: 100%;
  right: 0px;
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.registerMatchMaking {
  opacity: 0;
  display: none;
}

.appbarMobile {
  box-shadow: 0 3px 17px 0 rgba(0, 0, 0, 0.16);
  position: relative;
  z-index: 999;
}

.prevBtn {
  position: fixed;
  top: 45%;
  right: 20px;
  color: #6d5aac;
  cursor: pointer;
  background: transparent !important;
}

.nextBtn {
  position: fixed;
  background: transparent !important;
  top: 45%;
  left: 20px;
  color: #6d5aac;
  cursor: pointer;
}

.stepArea {
  width: 70%;
  margin: auto;
}

.disableArrow {
  filter: grayscale(1);
  opacity: 0.5;
}

.StepperContent {
  position: relative;
  z-index: 10;
  min-height: 600px;
  margin-top: 10px;
  border-radius: 20px;
  box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
  background-color: #fff;
  transition: all 0.3s;
  padding-bottom: 20px;
  /*overflow-y: scroll;*/
  /*overflow-x: hidden;*/
  /*-ms-overflow-style: none; !* for Internet Explorer, Edge *!*/
}

::-webkit-scrollbar {
  width: 5px;
  background: transparent; /* make scrollbar transparent */
}

::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 10px;
}

.indicator {
  height: 50px;
  text-align: center;
}

.reserveBtn {
  width: 120px !important;
  height: 34px !important;
  padding: 5px;
  border-radius: 10px;
  border: solid 1px #46b1a1;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  background: #46b1a1 !important;
  color: white;
}

.loginBtn {
  width: 120px !important;
  height: 34px !important;
  padding: 5px;
  border-radius: 10px;
  border: solid 1px #46b1a1;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #46b1a1 !important;
  background: transparent !important;
}

.StepperArea {
  background: #f9ffff;
  position: relative;
}

.circleOne {
  position: absolute;
  top: -180px;
  left: -180px;
  background: #e9fbff;
  width: 500px;
  height: 500px;
  filter: blur(10px);
  border-radius: 50%;
}

.circleTwo {
  position: absolute;
  bottom: -200px;
  left: -180px;
  background: #f3f7ff;
  width: 500px;
  height: 500px;
  filter: blur(10px);
  border-radius: 50%;
}

.circleThree {
  position: absolute;
  top: 25%;
  right: -180px;
  background: #eafffa;
  width: 300px;
  height: 300px;
  filter: blur(10px);
  border-radius: 50%;
}

.footer {
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  text-align: center;
  color: #6d6d6d;
  z-index: 10;
  position: relative;
}

.terms {
  width: 122px;
  height: 26px;
  /*margin: 0 267px 0 0;*/
  /*padding: 3px 25px 2px 22px;*/
  padding: 5px;
  background-color: #46b1a1;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  /*line-height: 2.25;*/
  letter-spacing: normal;
  color: #fbfbfb;
  text-align: center;
  border-radius: 10px 10px 0px 0px;
}

a {
  text-decoration: none;
}
</style>